import { render, staticRenderFns } from "./SalesChannelForDB.vue?vue&type=template&id=7721ccb6&scoped=true"
import script from "./SalesChannelForDB.vue?vue&type=script&lang=js"
export * from "./SalesChannelForDB.vue?vue&type=script&lang=js"
import style0 from "./SalesChannelForDB.vue?vue&type=style&index=0&id=7721ccb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7721ccb6",
  null
  
)

export default component.exports